import {Reducer} from "redux";
import {IApplicationState} from "../types";

const updateLayer: Reducer<IApplicationState['map']> = (state, action): IApplicationState['map'] => {
    const {layername, type} = action.payload;
    const layerNamesByType = {...state?.layerNamesByType};
    const layerState = {...state?.layerState};
    layerState[type].name = layername;
    layerNamesByType[type] = layername;
    return {...state, layerNamesByType, layerState} as IApplicationState['map'];
}

export { updateLayer };
